var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default"},[_c('img',{attrs:{"src":require("../assets/quexing-bg.png"),"alt":""}}),_c('p',[_vm._v("页面正在准备中，敬请期待")])])
}]

export { render, staticRenderFns }